/* eslint-disable react-hooks/exhaustive-deps */
import authDispatcher, {
  SOCIAL_NOT_REGISTERED_STATUS,
} from '../../action/auth';
import AccountInfo from './AccountInfo';
import CompleteProfile from './CompleteProfile';
import VerifyOTP from './VerifyOTP';
import { LogoSmall, NotiEmailIcon } from '@/assets/svg';
import { urlLabel } from '@/enum/PermissionEnum';
import { signInWithGoogle, signInWithApple } from '@/firebase';
import {
  ALPHA_NUMERIC_REGEX,
  PASSWORD_REGEX,
} from '@/helpers/validationHelpers/validationSchema';
import CustomButton from '@/new-components/CustomButton';
import ModalConfirmationMobile from '@/new-components/CustomModal/ModalConfirmationMobile';
import customToast from '@/new-components/CustomNotification';
import {
  checkRegexFullName,
  validateEmail,
  validateIdentity,
  validateMobile,
  validateNRIC,
} from '@/utils/validation';
import { safeWindowOpen } from '@/utils/windowUtils';
import { Box, IconButton, Typography, withStyles } from '@material-ui/core';
import { KeyboardArrowLeft } from '@material-ui/icons';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactRecaptcha3 from 'react-google-recaptcha3';
import Progress from 'react-progress-2';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

const CustomTitle = withStyles({
  root: {
    fontSize: 18,
    fontFamily: 'Lato',
    fontWeight: 700,
    color: '#191919',
  },
})(Typography);

export const REGISTER_PROCESS_STEPS = {
  ACCOUNT_INFO: 'accountInfo',
  PERSONAL_INFO: 'personalInfo',
  VERIFY_OTP: 'verifyOTP',
};

const PatientRegister = ({ history }) => {
  const { singpassUserInfo } = useSelector((state) => state.auth);
  const { socialUserInfo } = useSelector((state) => state.auth);
  const [showLoading, setShowLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(0);
  const [showNoticeModal, setShowNoticeModal] = useState(false);
  const [showNoticeEmailModal, setShowNoticeEmailModal] = useState(false);
  const [unitNumber, setUnitNumber] = useState(false);
  const [loginInfo, setLoginInfo] = useState(null);

  const [confirmPassword, setConfirmPassword] = useState('');
  const [didSendOTP, setDidSendOTP] = useState(false);
  const [reCaptchaToken, setReCaptchaToken] = useState('');
  const [formValue, setFormValue] = useState({
    email: '',
    countryCode: 'SG',
    phoneNumber: '',
    password: '',
    requestKey: '',
    otp: '',
    fullName: '',
    dateOfBirth: '',
    gender: '',
    identityType: '',
    identityNumber: '',
    ethnicGroup: 'Others',
    notificationEmail: '',
    isMinmedBooking: true,
    loginType: 'Manual',
    socialToken: '',
    postalCode: '',
    unitNumber: '',
    address: '',
    floor: '',
    ignoredUnitNumber: false,
  });

  const isSocialLogin = !isEmpty(socialUserInfo);

  useEffect(() => {
    ReactRecaptcha3.init(process.env.REACT_APP_RECAPTCHA_TOKEN);
    return () => {
      authDispatcher.setState('singpassUserInfo', null);
      authDispatcher.setState('socialUserInfo', null);
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(singpassUserInfo)) {
      setFormValue({
        requestKey: formValue.requestKey,
        loginType: 'Singpass',
        state: singpassUserInfo.state,
        nonce: singpassUserInfo.nonce,
        email: singpassUserInfo.email,
        countryCode: singpassUserInfo.countryCode || 'SG',
        dateOfBirth: singpassUserInfo.dateOfBirth,
        ethnicGroup: singpassUserInfo.ethnicGroup,
        fullName: singpassUserInfo.fullName,
        gender: singpassUserInfo.gender,
        identityNumber: singpassUserInfo.identityNumber,
        phoneNumber: singpassUserInfo.mobile,
        identityType: 'NRIC',
      });
      setCurrentStep(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singpassUserInfo]);
  useEffect(() => {
    if (isSocialLogin) {
      setFormValue((prev) => ({
        ...prev,
        loginType: socialUserInfo.loginType,
        email: socialUserInfo.email || '',
        socialToken: socialUserInfo.token || '',
      }));
      setCurrentStep(1); // Skip account info → complete profile
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socialUserInfo]);

  const handleChangeForm = (key) => (e, newValue) => {
    let value = get(e, 'target.value');
    switch (key) {
      case 'phoneNumber':
        value = e.value;
        break;

      case 'email':
        value = get(e, 'target.value').trim();
        break;

      case 'dateOfBirth':
        value = moment(e).startOf('date').format();
        break;

      case 'gender':
        value = newValue;
        break;

      case 'ignoredUnitNumber':
        value = get(e, 'target.checked');
        break;

      case 'postalCode':
        // Regex labnum number contain only number without dot and comma symbol
        const regexNumber = /^[0-9\b]+$/;
        value = regexNumber.test(value) ? value : '';
        break;

      default:
        break;
    }

    if (key === 'identityType') {
      setFormValue({
        ...formValue,
        [key]: value,
        // identityNumber: '',
      });
    } else if (key === 'ignoredUnitNumber') {
      setFormValue({
        ...formValue,
        [key]: value,
        floor: '',
        unitNumber: '',
      });
      setUnitNumber('');
    } else setFormValue({ ...formValue, [key]: value });
  };

  const handleClearForm = (key) => {
    if (key === 'confirmPassword') {
      setConfirmPassword('');
    } else if (key === 'unitNumber') {
      setUnitNumber('');
      setFormValue({
        ...formValue,
        unitNumber: '',
        floor: '',
      });
    } else setFormValue({ ...formValue, [key]: '' });
  };

  const handleCountryCode = (value) => {
    setFormValue({
      ...formValue,
      countryCode: value,
    });
  };

  const handleChangeUnitNumber = (e) => {
    const value = e.target.value;
    const floor = value.slice(0, 2) || '';
    let unitNumber =
      value.indexOf('-') >= 0 ? value.slice(value.indexOf('-') + 1) : '';

    if (
      !(
        !ALPHA_NUMERIC_REGEX.test(floor) ||
        !ALPHA_NUMERIC_REGEX.test(unitNumber)
      )
    ) {
      setUnitNumber(value);
      setFormValue({
        ...formValue,
        unitNumber,
        floor,
      });
    }
  };

  const goLogin = () => {
    history.push(`/${urlLabel.patientLogin}`);
  };

  const handleNext = () =>
    setCurrentStep((prevActiveStep) => prevActiveStep + 1);

  const handleBack = () => {
    if (isSocialLogin || !isEmpty(singpassUserInfo)) {
      history.push(`/${urlLabel.patientLogin}`);
    } else {
      setCurrentStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleSingpassLogin = async () => {
    let redirectUrl = `https://dev.minc.saigontechnologysoftware.com/#/login-success`;

    if (process.env.NODE_ENV !== 'development') {
      redirectUrl = `https://${process.env.REACT_APP_MINC_DOMAIN}/#/login-success`;
    }
    localStorage.setItem('singpassFlow', 'signup');
    authDispatcher.getSingpassLoginUrl(
      encodeURIComponent(redirectUrl),
      (result) => {
        safeWindowOpen(result.url);
      }
    );
  };

  const validAccountInfo = (data) => {
    let valid = true;
    let errors = {};

    if (!validateMobile(data.phoneNumber, data.countryCode)) {
      errors = { ...errors, phoneNumber: 'Phone number is invalid!' };
      valid = false;
    }

    if (!validateEmail(data.email)) {
      errors = { ...errors, email: 'Email is invalid!' };
      valid = false;
    }

    if (!data.email || !data.password || !data.phoneNumber) {
      errors = {
        ...errors,
        email: 'Email is required!',
        password: 'Password is required!',
        phoneNumber: 'Phone is required!',
      };

      valid = false;
    }

    if (confirmPassword !== data.password) {
      errors = {
        ...errors,
        confirmPassword: 'Your Password and Confirmation password must match.',
      };
      valid = false;
    }

    if (!PASSWORD_REGEX.test(data.password)) {
      errors = {
        ...errors,
        password:
          'Password must be 8-32 characters long and includes at least one number, one letter (uppercase or lowercase), and may contain special characters like !@#$%^&*(),_-+=',
      };

      valid = false;
    }
    setErrors(errors);
    return valid;
  };

  const validCompleteProfile = (data) => {
    let valid = true;
    let errors = {};

    if (isSocialLogin) {
      if (!validateMobile(data.phoneNumber, data.countryCode)) {
        errors = { ...errors, phoneNumber: 'Phone number is invalid!' };
        valid = false;
      }
      if (!validateEmail(data.email)) {
        errors = { ...errors, email: 'Email is invalid!' };
        valid = false;
      }
    }

    if (formValue.identityNumber) {
      const validIdentityNumber =
        formValue.identityType === 'NRIC'
          ? validateNRIC(formValue.identityNumber)
          : validateIdentity(formValue.identityNumber);

      if (!validIdentityNumber) {
        errors = { ...errors, identityNumber: 'Identity Number is invalid!' };
        valid = false;
      }
    }

    if (isEmpty(singpassUserInfo)) {
      if (formValue.fullName) {
        const isValidFullName = checkRegexFullName(formValue.fullName);
        if (!isValidFullName) {
          errors = {
            ...errors,
            fullName:
              'Full Name must contain letters only or letters combined with special characters',
          };
          valid = false;
        }
      }
    }

    if (!isEmpty(singpassUserInfo)) {
      if (!validateMobile(data.phoneNumber, data.countryCode)) {
        errors = { ...errors, phoneNumber: 'Phone number is invalid!' };
        valid = false;
      }

      if (!validateEmail(data.email)) {
        errors = { ...errors, email: 'Email is invalid!' };
        valid = false;
      }
    }

    setErrors(errors);
    return valid;
  };

  const handleNextAccountStep = () => {
    setShowLoading(true);
    // Check invalid

    if (!validAccountInfo(formValue)) {
      setShowLoading(false);
      return;
    }

    setErrors({});
    // Email/mobile uniqueness is validated by BE on register.
    handleNext();
    setShowLoading(false);
  };

  const handleNextCompleteProfileStep = () => {
    if (!validCompleteProfile(formValue)) {
      setShowLoading(false);
      return;
    }
    setErrors({});
    // Mobile uniqueness is validated by BE on register.
    if (!isEmpty(singpassUserInfo)) {
      setShowLoading(true);
      handleFinalSingpassStep();
    } else {
      handleNext();
    }
  };

  const handleFinalStep = (otp) => {
    // Register
    authDispatcher.registerPatient(
      {
        ...formValue,
        otp,
      },
      (isSuccess) => {
        setShowLoading(false);
        if (isSuccess) {
          setShowNoticeEmailModal(true);
        }
      }
    );
  };

  const handleFinalSingpassStep = (otp) => {
    // Register
    authDispatcher.registerPatient(formValue, (isSuccess, result) => {
      setShowLoading(false);
      if (isSuccess) {
        setShowNoticeModal(true);
        setLoginInfo(result);
      }
    });
  };

  const handleFinalSocialStep = (otp) => {
    setShowLoading(true);
    authDispatcher.registerPatient(
      { ...formValue, otp },
      (isSuccess, result) => {
        setShowLoading(false);
        if (isSuccess) {
          setLoginInfo(result);
          setShowNoticeModal(true);
        }
      }
    );
  };

  const sendOTP = (reCaptchaToken, callback) => {
    Progress.hide();

    authDispatcher.checkPatientPreregistersAccount(
      {
        email: formValue.email,
        phoneNumber: formValue.phoneNumber,

        countryCode: formValue.countryCode,
        reCaptchaToken,
      },
      (result) => {
        callback && callback();
        setFormValue({ ...formValue, requestKey: result });
      }
    );
  };

  const getReCaptcha = () => {
    ReactRecaptcha3.getToken().then(
      (resp) => {
        Progress.show();
        setShowLoading(true);
        setDidSendOTP(false);
        sendOTP(resp, () => {
          Progress.hide();
          setDidSendOTP(true);
          setShowLoading(false);
          setReCaptchaToken(resp);
        });
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const reSendOTP = () => {
    Progress.show();
    setDidSendOTP(false);
    getReCaptcha();
    // sendOTP(reCaptchaToken, () => {
    //   Progress.hide();
    //   setDidSendOTP(true);
    // });
  };

  const handleSocialLoginSuccess = (result) => {
    setShowLoading(false);
    setLoginInfo(result);
    setShowNoticeModal(true);
  };

  const handleGoogleLogin = () => {
    signInWithGoogle({
      loginSuccess: (user, token) => {
        const email = user?.email || '';
        handleSocialCheckAndLogin(
          email,
          token,
          'Google',
          authDispatcher.loginPatientWithGoogle
        );
      },
      loginFailed: (errorMessage) => {
        setShowLoading(false);
        customToast('error', errorMessage);
      },
    });
  };

  const handleSocialCheckAndLogin = (email, token, loginType, loginAction) => {
    setShowLoading(true);
    loginAction(
      token,
      (result) => {
        handleSocialLoginSuccess(result);
      },
      (message, status) => {
        setShowLoading(false);
        if (status === SOCIAL_NOT_REGISTERED_STATUS) {
          // New user → complete registration with the social account
          authDispatcher.setState('socialUserInfo', {
            email,
            token,
            loginType,
          });
          history.push(`/${urlLabel.patientRegister}`);
          return;
        }
        customToast('error', message || `${loginType} login failed`);
      }
    );
  };

  const handleAppleLogin = () => {
    signInWithApple({
      loginSuccess: (user, token) => {
        const email = user?.email || '';
        handleSocialCheckAndLogin(
          email,
          token,
          'Apple',
          authDispatcher.loginPatientWithApple
        );
      },
      loginFailed: (errorMessage) => {
        setShowLoading(false);
        customToast('error', errorMessage);
      },
    });
  };

  const STEPS = [
    {
      key: REGISTER_PROCESS_STEPS.ACCOUNT_INFO,
      component: (
        <AccountInfo
          loading={showLoading}
          errors={errors}
          formValue={formValue}
          goLogin={goLogin}
          handleChangeForm={handleChangeForm}
          handleSubmit={handleNextAccountStep}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          handleClearForm={handleClearForm}
          handleCountryCode={handleCountryCode}
          handleSingpassLogin={handleSingpassLogin}
          handleAppleLogin={handleAppleLogin}
          handleGoogleLogin={handleGoogleLogin}
        />
      ),
    },
    {
      key: REGISTER_PROCESS_STEPS.PERSONAL_INFO,
      name: 'Complete profile',
      component: (
        <CompleteProfile
          loading={showLoading}
          errors={errors}
          formValue={formValue}
          handleChangeForm={handleChangeForm}
          handleSubmit={handleNextCompleteProfileStep}
          unitNumber={unitNumber}
          handleChangeUnitNumber={handleChangeUnitNumber}
          handleClearForm={handleClearForm}
          handleCountryCode={handleCountryCode}
          isSingpass={!isEmpty(singpassUserInfo)}
          isSocialLogin={isSocialLogin}
        />
      ),
    },
    {
      key: REGISTER_PROCESS_STEPS.VERIFY_OTP,
      name: 'Create an account',
      component: (
        <VerifyOTP
          getReCaptcha={getReCaptcha}
          didSendOTP={didSendOTP}
          reSendOTP={reSendOTP}
          formValue={formValue}
          handleSubmit={isSocialLogin ? handleFinalSocialStep : handleFinalStep}
        />
      ),
    },
  ];

  if (
    process.env.REACT_APP_MINC_DOMAIN &&
    window.location.host === process.env.REACT_APP_MINC_DOMAIN &&
    window.location.hash === `#/${urlLabel.patientRegister}`
  ) {
    return <Redirect to={`${urlLabel.register}`} />;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      p={2.5}
      height={'100dvh'}
    >
      {[REGISTER_PROCESS_STEPS.ACCOUNT_INFO].includes(
        STEPS[currentStep].key
      ) ? (
        <Box mb={5}>
          <LogoSmall />
        </Box>
      ) : (
        <>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box flex={1}>
              <IconButton onClick={handleBack} disabled={currentStep === 0}>
                <KeyboardArrowLeft />
              </IconButton>
            </Box>
            <Box flex={2} textAlign="center">
              <CustomTitle>{STEPS[currentStep].name}</CustomTitle>
            </Box>
            <Box flex={1}></Box>
          </Box>
        </>
      )}

      {STEPS[currentStep].component}

      {showNoticeModal && (
        <ModalConfirmationMobile
          open={showNoticeModal}
          onClose={() => {
            if (!isEmpty(singpassUserInfo)) {
              authDispatcher.setState('singpassUserInfo', null);
              history.push(`/${urlLabel.patientLogin}`);
            }
            if (isSocialLogin) {
              authDispatcher.setState('socialUserInfo', null);
              history.push(`/${urlLabel.patientLogin}`);
            }
            setShowNoticeModal(false);
          }}
          onClick={() => {
            authDispatcher.loginSuccess(loginInfo, formValue.email);
            authDispatcher.setState('singpassUserInfo', null);
            authDispatcher.setState('socialUserInfo', null);
            setShowNoticeModal(false);
            history.push(`/${urlLabel.teleconsultNow}`);
          }}
          title={
            <Box
              height={40}
              width="100%"
              textAlign="center"
              position="relative"
            >
              <LogoSmall style={{ position: 'absolute', left: 0 }} />
              <CustomTitle style={{ lineHeight: 2.5 }}>Notice</CustomTitle>
            </Box>
          }
          height={'unset'}
          subContent={
            <Box
              color="#292929"
              fontSize={16}
              px={2.5}
              mt={8}
              textAlign="left"
              height={'calc(100vh - 400px)'}
            >
              <p>
                Minmed Clinic (Kallang) is a MOH-licensed telemedicine provider.
              </p>

              <p>
                Telemedicine is suitable for non-emergency conditions. There are
                limitations and the consult may be cancelled without charge.
              </p>
              <p>
                Find out more in our{' '}
                <a
                  className="custom-link"
                  target="blank"
                  href="https://minmed.sg/teleconsult-doctor/#faq"
                >
                  FAQs
                </a>
                . Please proceed to the nearest Accident and Emergency facility
                if you need urgent medical attention.
              </p>
              <p>
                Minmed Clinic (Kallang) is a MOH-licensed telemedicine provider.
              </p>
              <p>
                For any enquiries, please contact us at{' '}
                <a className="custom-link" href="mailto: ask@minmed.sg">
                  ask@minmed.sg
                </a>
                .
              </p>
            </Box>
          }
        />
      )}

      {showNoticeEmailModal && (
        <ModalConfirmationMobile
          open={showNoticeEmailModal}
          onClose={() => setShowNoticeModal(false)}
          mainContent="Almost there!"
          title={<Box height={40}></Box>}
          subContent={
            <Box color="#666666" fontSize={16} px={7} mt={2} textAlign="center">
              <p>
                Please click on the verification link in your email to activate
                your account.
              </p>
            </Box>
          }
          otherActionsContent={() => (
            <CustomButton
              onClick={goLogin}
              variant="contained"
              color="primary"
              style={{ width: '100%', height: 48 }}
              margin="0 16px"
            >
              Done
            </CustomButton>
          )}
          Icon={<NotiEmailIcon style={{ marginTop: 100 }} />}
        />
      )}
    </Box>
  );
};

export default PatientRegister;
